export default {
    en: {
        CHALLENGE_DIFFICULTY_UNRATED_TEXT: 'Unrated',
        CHALLENGE_DIFFICULTY_UNRATED_TOOLTIP: 'Not enough attempts have been made to determine difficulty.',

        CHALLENGE_DIFFICULTY_EASY_TEXT: 'Easy',
        CHALLENGE_DIFFICULTY_MODERATE_TEXT: 'Moderate',
        CHALLENGE_DIFFICULTY_DIFFICULT_TEXT: 'Difficult',

        CHALLENGE_DIFFICULTY_RATED_TOOLTIP: '{successRate}% of {attempts} submissions are correct.',


    }
};
